import { z } from "zod";
import {
  DEFAULT_SCRAPE_COUNTRY_CODE,
  ScrapeCountryCodeSchema,
} from "../enums/scrape-country";

// The single canonical definition of a Website's crawl configuration, reused
// by the HTTP API and persisted flat on the `website_configs` table.
export const WebsiteCrawlConfigSchema = z.object({
  // Explicit list of URLs to seed the crawl with; defaults to the website's
  // origin_url when empty.
  seedUrls: z.array(z.url()).optional(),
  // Hard cap on pages fetched per website.
  maxPages: z.number().int().min(1).max(1000).default(50),
  // How deep to follow links from the seed set (0 = seeds only).
  maxDepth: z.number().int().min(0).default(1),
  // Country the site's pages are rendered from, via the ScrapingBee proxy.
  countryCode: ScrapeCountryCodeSchema.default(DEFAULT_SCRAPE_COUNTRY_CODE),
});

export type WebsiteCrawlConfig = z.infer<typeof WebsiteCrawlConfigSchema>;
